/** `crm.pwa` strings (install and update prompts), kept apart from the main catalog */
export const englishPwaMessages = {
  install_app: "Install app",
  install: "Install",
  dismiss: "Dismiss",
  banner_title: "Install %{name}",
  banner_body: "Add it to your home screen to open it like an app.",
  ios_instructions: 'Tap Share, then "Add to Home Screen".',
  update_available: "A new version is available.",
  reload: "Reload",
};
